<template>
  <section class="page-section page-section--auction mt-0">
    <div class="container">
      <div class="row justify-content-center text-center mb-2">
        <div class="col-11">
          <p class="fw-bold" v-if="btnOptions" v-html="btnOptions[status]['text']"></p>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-9">
          <a class="auction__btn" :class="btnOptions[status]['class']" href="#" @mousedown="bid" @touchstart="bid">
            <div class="content text-center">
              <span class="material-icons material-icons-outlined"> {{ btnOptions[status]['icon'] }}</span>
              <p class="auction__btn--text mb-0">{{ btnOptions[status]['iconText'] }}</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {visitor} from "../../stores/visitor";

export default {
  props: {
    status: {
      type: String,
      default: 'running',
    }
  },
  setup() {
    const store = visitor()

    return {
      store
    }
  },
  emits: ['buy', 'test'],
  data() {
    return {
      btnOptions: {
        "test": {
          text: "Let op! de veiling voor dit item gaat zo beginnen de knop zal dan een blauwe kleur krijgen.",
          class: "bg-buy text-white",
          icon: "hourglass_empty",
          iconText: "Klik om te testen,",
        },
        "start": {
          text: "Let op! de veiling voor dit item gaat zo beginnen de knop zal dan een blauwe kleur krijgen",
          class: "disabled bg-light",
          icon: "hourglass_empty",
          iconText: "even geduld",
        },
        "max": {
          text: "U heeft het maximaal aantal items voor deze veiling bereikt en je kunt niet meer bieden",
          class: "disabled bg-danger text-white",
          icon: "dangerous",
          iconText: "limiet bereikt",
        },
        "running": {
          text: "Klik op de blauwe knop om de klok te stoppen",
          class: "bg-buy text-white",
          icon: "shopping_cart_checkout",
          iconText: "item kopen",
        },
        "pauze": {
          text: "De klok is even gepauzeerd we gaan zo verder.",
          class: "disabled bg-light",
          icon: "pause",
          iconText: "even geduld",
        },
        "win": {
          text: "Je hebt gewonnen!<br> Het item is van jou!",
          class: "disabled bg-win",
          icon: "check",
          iconText: "Gefeliciteerd",
        },
        "late": {
          text: "Helaas niet gewonnen,<br> probeer het bij het volgende item nog een keer!",
          class: "disabled bg-sold",
          icon: "error_outline",
          iconText: "Te laat!",
        },
        "early": {
          text: "Let op,<br>bied binnen de prijsrange",
          class: "disabled bg-soon",
          icon: "production_quantity_limits",
          iconText: "Helaas Mislukt!",
        },
        "waiting": {
          text: "",
          class: "disabled bg-light",
          icon: "hourglass_empty",
          iconText: "even geduld",
        },
      }

    };
  },
  methods: {
    bid(e) {
      if(this.status === 'running') {
          this.$emit('buy');
      }
      else if(this.status === 'test'){
        this.$emit('test');
      }
      e.preventDefault()
      return false;
    },
  }
} 
</script>

